import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'busy-indicator',
  templateUrl: './busy-indicator.component.html',
  styleUrls: ['./busy-indicator.component.scss']
})

export class BusyIndicatorComponent implements OnInit {
  constructor() { }

  @Input() show: boolean = true;
  @Input() margins: boolean = true;

  ngOnInit() { }
}
